import PropTypes from "prop-types";
import { getAvatarUrl, getInitials } from "lib/authUserDisplay";

export default function HeaderUserAvatar({ user, className = "h-8 w-8" }) {
  const avatarUrl = getAvatarUrl(user);
  const initials = getInitials(user);

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        key={avatarUrl}
        className={`shrink-0 rounded-full border border-slate-200 object-cover ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full border border-slate-200 bg-brand-900 text-xs font-bold text-white ${className}`}
      aria-hidden
    >
      {initials}
    </div>
  );
}

HeaderUserAvatar.propTypes = {
  user: PropTypes.object,
  className: PropTypes.string,
};
